import { BiMapPin } from "react-icons/bi";
import { FiMail, FiPhone } from "react-icons/fi";
import { mainContact } from "../../data/artemulkContent";

const ContactInfo = () => {
  const telPrimary = mainContact.phone.replace(/\s/g, "");
  const telAlt = mainContact.phoneAlt.replace(/\s/g, "");

  return (
    <div className="grid grid-cols-1 gap-6 py-10 sm:grid-cols-2 md:grid-cols-3">
      <div className="text-center">
        <div className="icon-box !h-14 !w-14 !bg-primary text-white mx-auto text-2xl">
          <FiPhone />
        </div>
        <h2 className="mt-2 text-lg font-semibold">Telefon</h2>
        <p>
          <a href={`tel:${telPrimary}`} className="text-primary hover:underline">
            {mainContact.phone}
          </a>
        </p>
        <p className="text-sm text-muted mt-1">
          <a href={`tel:${telAlt}`}>{mainContact.phoneAlt}</a>
        </p>
      </div>
      <div className="text-center">
        <div className="icon-box !h-14 !w-14 !bg-primary text-white mx-auto text-2xl">
          <FiMail />
        </div>
        <h2 className="mt-2 text-lg font-semibold">E-posta</h2>
        <p>
          <a
            href={`mailto:${mainContact.email}`}
            className="text-primary hover:underline normal-case"
          >
            {mainContact.email}
          </a>
        </p>
      </div>
      <div className="text-center">
        <div className="icon-box !h-14 !w-14 !bg-primary text-white mx-auto text-2xl">
          <BiMapPin />
        </div>
        <h2 className="mt-2 text-lg font-semibold">Merkez Ofis</h2>
        <p className="text-sm text-muted px-2">{mainContact.address}</p>
        <p className="mt-2">
          <a href="/about#subelerimiz" className="text-primary hover:underline text-sm">
            İstanbul · İzmir · Balıkesir · Bandırma · Bodrum →
          </a>
        </p>
      </div>
    </div>
  );
};

export default ContactInfo;
